import type { PropsWithChildren } from 'react';
import { generatePath } from 'react-router-dom';
import { Button } from '@accure/ui';
import { ChevronRight } from 'lucide-react';

import { Link } from '@/components/ui/link';
import type { Alert } from '@/entities/alert';

type WarrantyDetailsLinkProps = {
  alert: Alert;
};

export function WarrantyDetailsLink({
  alert,
  children,
}: PropsWithChildren<WarrantyDetailsLinkProps>) {
  /* ───────────── 4) Render link/button ────────── */
  return (
    <Link
      to={generatePath('/asset/:siteId/warranty', {
        siteId: alert.id ?? '',
      })}
    >
      {children ?? (
        <Button>
          Go to Warranty
          <ChevronRight />
        </Button>
      )}
    </Link>
  );
}
